import { SpotReserveEntityEnum, SpotType } from '@nova/core';

import type { SpotGridAssignment, SpotGridItem } from '@satellite/composables/yard/spotGridTypes';
import type {
  YardSpotDetails,
  YardSpotReserveDetails,
  YardSpotAssignmentDetails
} from '@satellite/composables/useYardSpotPresenterV2';

function gridAssignmentToSpotAssignment(
  assignment: SpotGridAssignment,
  warehouseId: string
): YardSpotAssignmentDetails {
  return {
    id: assignment.id,
    spotId: assignment.spotId,
    warehouseId,
    assetVisitId: assignment.assetVisitId ?? undefined,
    assetContainerId: assignment.assetContainerId ?? undefined,
    createDateTime: assignment.createDateTime,
    lastChangedDateTime: assignment.lastChangedDateTime,
    isActive: true,
    tags: null,
    observation: assignment.observation ?? undefined,
    assetVisit: assignment.assetVisit ?? undefined,
    assetContainer: assignment.assetContainer ?? undefined
  };
}

/**
 * Maps a spot-grid BFF row to a {@link YardSpotDetails} shape so presenters and yard UI
 * (which expect `spotAssignments`, `spotReserves`, `openMoveTasks`, `openCheckTasks`) can run off grid data.
 */
export function spotGridItemToYardSpotDetails(
  item: SpotGridItem,
  warehouseId: string
): YardSpotDetails {
  const spotId = item.id;
  const spotType = item.type === SpotType.DOCKING ? SpotType.DOCKING : SpotType.PARKING;

  const gridAssignment = item.spotAssignments?.[0];
  const spotAssignments: YardSpotAssignmentDetails[] = [];
  if (gridAssignment?.id) {
    spotAssignments.push(gridAssignmentToSpotAssignment(gridAssignment, warehouseId));
  }

  return {
    id: spotId,
    code: item.code ?? '',
    type: spotType,
    isActive: item.isActive ?? false,
    status: item.status,
    spotAreaId: item.spotAreaId,
    spotReserves: (item.spotReserves ?? []).map((reserve): YardSpotReserveDetails => ({
      id: reserve.id,
      isActive: reserve.isActive,
      spotId,
      warehouseId,
      objectId: reserve.objectId ?? undefined,
      entityName: reserve.entityName,
      createDateTime: reserve.createDateTime,
      lastChangedDateTime: reserve.lastChangedDateTime,
      tags: null,
      validUntil: reserve.validUntil ?? undefined
    })),
    spotAssignments,
    createDateTime: item.createDateTime,
    lastChangedDateTime: item.lastChangedDateTime,
    openMoveTasks: item.openMoveTasks ?? [],
    openCheckTasks: item.openCheckTasks ?? []
  };
}
